import { Dispatch, SetStateAction } from "react";
import { createStore } from "./utils";
import { ContactDetailsSection } from "../components/SidebarPanel";

export type AvailableSidebarContentType = "ContactDetails";
export interface ContentTypeData {
  ContactDetails?: {
    enduserId: string;
    selectedSection: ContactDetailsSection; // TODO: switch to a discriminated string union
  };
}

export const SIDEBAR_MIN_WIDTH = 250;
export const SIDEBAR_MAX_WIDTH = 600;
export const SIDEBAR_DEFAULT_WIDTH = 400;

interface SidebarStore {
  isOpen: boolean;
  contentType: AvailableSidebarContentType | undefined;
  width: number;
  toggleIsOpen: () => void;
  openSidebar: <T extends AvailableSidebarContentType>(contentType: T, data: ContentTypeData[T]) => void;
  setContentType: Dispatch<SetStateAction<AvailableSidebarContentType | undefined>>;
  setWidth: (width: number) => void;
  contentTypeData: ContentTypeData;
  setContentTypeData: Dispatch<SetStateAction<ContentTypeData>>;
}

export const { useStore: useSidebarStore, useShallowStore: useShallowSidebarStore } = createStore<SidebarStore>(
  (set) => ({
    isOpen: false,
    contentType: undefined,
    width: SIDEBAR_MIN_WIDTH,
    toggleIsOpen: () =>
      set((state) => {
        return {
          isOpen: !state.isOpen,
        };
      }),
    openSidebar: (contentType, data) =>
      set((state) => ({
        isOpen: true,
        contentType,
        contentTypeData: {
          ...state.contentTypeData,
          ContactDetails: data,
        },
      })),
    setContentType: (newVal) =>
      set((state) => {
        const prev = state.contentType;
        const contentType = typeof newVal === "function" ? newVal(prev) : newVal;
        return {
          contentType,
        };
      }),
    setWidth: (width) =>
      set({
        width: Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, width)),
      }),
    contentTypeData: {
      ContactDetails: {
        enduserId: "",
        selectedSection: "Information",
      },
    },
    setContentTypeData: (newVal) =>
      set((state) => {
        const prev = state.contentTypeData;
        const contentTypeData = typeof newVal === "function" ? newVal(prev) : newVal;
        return {
          contentTypeData,
        };
      }),
  }),
  {
    persist: "localStorage",
    name: "SIDEBAR_STATE",
    version: 2,
    migrate: (persistedState: any, version: number) => {
      if (version < 2) {
        // Migrate width from narrow values to 400px minimum
        if (persistedState.width < SIDEBAR_DEFAULT_WIDTH) {
          persistedState.width = SIDEBAR_DEFAULT_WIDTH;
        }
      }
      return persistedState;
    },
  }
);
